import script from "./BottomTabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomTabBar.vue?vue&type=script&setup=true&lang=js"

import "./BottomTabBar.vue?vue&type=style&index=0&id=4d82b91c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d82b91c"]])

export default __exports__